import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { BaseService } from './base/base.service';
import { AppConfig } from './app-config';

import { Entity, CurrencyConversion, CurrencyConversionPayload } from '../models';
import { ListResponse, ObjectResponse } from '../interfaces';

@Injectable()
export class CurrencyConversionService extends BaseService<CurrencyConversion> {
  constructor(protected http: HttpClient, protected config: AppConfig) {
    super(http, config);
  }

  getAvailableEntities(): Observable<ListResponse<Entity>> {
    return this.http.get<ListResponse<Entity>>(`${this.getResourceUrl()}entities`);
  }

  saveCurrencyConversion(
    entityId: number,
    payload: CurrencyConversionPayload
  ): Observable<ListResponse<CurrencyConversion>> {
    return this.http.post<ListResponse<CurrencyConversion>>(`${this.getResourceUrl()}${entityId}`, payload);
  }

  updateCurrencyConversion(
    entityId: number,
    payload: CurrencyConversionPayload
  ): Observable<ListResponse<CurrencyConversion>> {
    return this.http.patch<ListResponse<CurrencyConversion>>(`${this.getResourceUrl()}${entityId}`, payload);
  }

  deleteCurrencyConversion(entityId: number): Observable<ObjectResponse<CurrencyConversion>> {
    return this.http.delete<ObjectResponse<CurrencyConversion>>(`${this.getResourceUrl()}${entityId}`);
  }

  protected getResourceUrl(): string {
    return `${this.baseUrl}entity-conversions/`;
  }
}
